import TwoPartsInfoBoxesSection from 'components/two-parts-info-boxes-section'
import {deviceManagementData} from 'content/home-page'
import React from 'react'

export default function DeviceManagement() {
  return (
    <TwoPartsInfoBoxesSection
      data={deviceManagementData}
      sectionBgColor="white"
      mainFlexDirection="row-reverse"
      showSeparator={false}
    />
  )
}
